module.exports = __webpack_public_path__ + "static/media/sb.12a5539d.svg";